import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IGroup } from '@ahryman40k/ts-fhir-types/lib/R4';
import { AbstractAddComponent } from '../../../shared/abstracts/add/abstract-add/abstract-add.component';
import { getGroupForm } from '../add-modal/group-add.component';

@Component({
  selector: 'inc-group-add',
  templateUrl: './group-add.component.html',
  styleUrls: ['./group-add.component.scss'],
})
export class GroupAddComponent extends AbstractAddComponent<IGroup> {
  constructor() {
    super();
  }

  resetForm(): FormGroup {
    return getGroupForm();
  }
}
